import { Panel, PanelType } from "@fluentui/react";
import React, { useCallback } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import BaseTelelirk from "../../../../components/generic/baseTelerik";
import AuthService from "../../../../services/authService";
import { CLAIM_PERSONA_ID } from "../../../../utils/helpers/roleHelpers";

interface IPanelReporteTelerikSupervisorIperc {
  isOpen: boolean;
  onDismiss: () => void;
}

export const PanelReporteTelerikSupervisorIperc = (
  props: IPanelReporteTelerikSupervisorIperc
) => {
  function obtenerUsuario() {
    return AuthService.getInfoToken(CLAIM_PERSONA_ID);
  }

  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"filtrar"}
          nameIconHeader=""
          subTextHeader="Reporte Iperc Por Equipo de Trabajo "
          textHeader="Reporte Iperc"
        />
      </>
    ),
    []
  );
  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderHeader={onRenderHeaderPanel}
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.large}
        isLightDismiss
      >
        <BaseTelelirk
          reportName="IpercReporteHistoricoSupervisor.trdx"
          parametros={{
            supervisorId: obtenerUsuario(),
          }}
        />
      </Panel>
    </div>
  );
};
